import flowRuleApi from '@/api/config/flowRuleApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList } from '@/types'
import { FlowRuleType } from '@/types/hydraulic'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchFlowRule(
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<FlowRuleType>, any> {
  return useQuery(
    [queryKeys.flowRule],
    async () => {
      const { data } = await flowRuleApi.getAll({ interfaceId })

      if (!data) return null

      return {
        list: data.data,
      }
    },
    queryOptions,
  )
}

export default useSearchFlowRule
